
<template>
    <div class="rule-content">
        <h3 class="title">
            {{ $t('redPacketMines.rule01Title') }}
        </h3>
        <ol class="list">
            <li>
                {{ $t('redPacketMines.rule01_1') }}
            </li>
            <li>
                {{ $t('redPacketMines.rule01_2') }}
            </li>
            <li>
                {{ $t('redPacketMines.rule01_3') }}
            </li>
        </ol>
        <!-- 
            ===================
        -->
        <h3 class="title">
            {{ $t('redPacketMines.rule02Title') }}
        </h3>
        <table class="table">
            <thead>
                <tr>
                    <th>
                        {{ $t('redPacketMines.rule02_column01A') }}
                    </th>
                    <th v-for="(cur, idx) of [5, 8, 10] " >
                        {{cur}}
                        <small class="unit">
                            {{ $t('redPacketMines.packetsShortened') }}
                        </small>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        {{ $t('redPacketMines.rule02_column01B') }}
                    </td>
                    <td  v-for="(cur, idx) of [2, 1.25, 1]">
                        {{ cur.toFixed(2) }}
                    </td>
                </tr>
            </tbody>
        </table>
        <!-- 
            ===================
        -->
        <h3 class="title">
            {{ $t('redPacketMines.rule03Title') }}
        </h3>
        <ol class="list">
            <li>
                {{
                    $t('redPacketMines.rule03_1', {
                        taxRate: iTaxRate,
                    })
                }}
            </li>
            <li>
                {{ $t('redPacketMines.rule03_2') }}
            </li>
            <li>
                {{ $t('redPacketMines.rule03_3') }}
            </li>
            <li>
                {{ $t('redPacketMines.rule03_4') }}
            </li>
            <li>
                <!-- 显示红包过期秒数 -->
                {{
                    $t('redPacketMines.rule03_5', {
                        sec: joinStateStore.config['overtime'],
                    })
                }}
            </li>
        </ol>
    </div>
</template>

<script lang="ts" setup> 
import { useJoinStateStore } from '@/stores/cansino/joinState';

const joinStateStore = useJoinStateStore(); 

const iTaxRate = computed(()=>{
    const aList = joinStateStore.config['tableList'];
    const aRate = aList.map(cur=>{
        return Number(cur.taxRate);
    });
    const aResult = [...new Set(aRate)];
    if (aResult.length > 1 && import.meta.env.DEV_MODE){
        console.error('注意，抽水率有多个');
    }
    return aResult[0];
});

</script>

<style lang="scss" scoped>
.rule-content{
    color: rgba(147, 172, 211, 1);
}

.title{
    color: white; 
    font-family: Kanit;
    font-weight: 600;
    font-size: 18px;
    line-height: 20px;
    margin: 0 0 10px;
}

.list{
    margin: 0 0 15px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    padding-left: 1.1em; 
    list-style: decimal !important;  // 显示数字序号 
    li{
        list-style: decimal !important;  // 显示数字序号 
    }
}

.table{
    width: 100%; 
    text-align: center; 
    // border-collapse: separate;
    // border-spacing: 0;
    overflow: hidden; 
    border-radius: 10px;
    border-style:hidden;  /* 消除掉外边框 */
    border-collapse: collapse; /* 消除单元格之间的空隙 */
    box-shadow: 0 0 0 1px rgba(42, 53, 70, 1); /* hack 一下加个阴影 */ 
    border: 1px solid rgba(42, 53, 70, 1);  
    font-weight: 500;
    font-size: 12px;
    margin: 0 0 15px; 

    thead{
        background-color: rgba(27, 38, 54, 1);
        color: white; 
    }
    tr th:nth-child(1),
    tr td:nth-child(1){
        background-color: rgba(28, 37, 50, 1);
        color: white; 
    }
    th,
    td{
        min-width: calc(100% / 4); 
        max-width: calc(100% / 3); 
        border:  solid 1px rgba(42, 53, 70, 1);
        padding: 1em 0.5em; 
    }
    .unit{
        color: rgba(151, 164, 176, 1); 
        font-size: 0.9em;
        font-weight: normal; 
    }
}

</style>
